import { autoinject } from 'aurelia-framework';
import { I18N } from 'aurelia-i18n';
import { TooltipOption } from 'bootstrap';

export interface TooltipTitle {
	buttonName: string;
	shortcut: string | string[];
}

@autoinject
export class TooltipUtils {
	constructor(private readonly i18n: I18N) {}

	/**
	 * @param {JQuery} element The element on to which the tooltip is attached
	 * @param {Title} title The title object which holds the strings used in the tooltip
	 * If the tooltip is derived from a reference to a manually declared button name, it is easier to set the title in typescript
	 * If this parameter is not specified, title needs to be specified in html. Useful if button name is simple translation from I18N
	 */
	public initTooltip(element: JQuery, title?: TooltipTitle) {
		if (element.data('originalTitle') !== undefined) {
			// tooltip is already initialised on this element, dispose first
			element.tooltip('dispose');
		}
		const options: TooltipOption = {
			delay: { show: 500, hide: 100 },
			trigger: 'hover',
		};
		if (title) {
			let shortcut: string = '';
			if (title.shortcut instanceof Array) {
				shortcut = title.shortcut
					.map((t) => this.i18n.tr(t))
					.join(' + ');
			} else {
				shortcut = this.i18n.tr(title.shortcut);
			}
			options.title = this.i18n.tr('utils.tooltip', {
				'button-name': this.i18n.tr(title.buttonName),
				shortcut,
			});
		}
		element.tooltip(options);
	}

	public static disposeTooltip(element: JQuery) {
		element.tooltip('dispose');
	}
}
